import { EmitterData } from '../../../../../types/systems';
import { FieldRules, rules, runRules, ValidatedJsonType, ValidationResult } from '../validator';

export function isEmitterJson(value: ValidatedJsonType): ValidationResult {
	const json = value as EmitterData;

	const fields: FieldRules[] = [
		{ key: 'id', actual: json.id, rules: [rules.optional(json.id, rules.isNumber(json.id))] },
		{ key: 'name', actual: json.name, rules: [rules.isString(json.name)] },
		{ key: 'side', actual: json.side, rules: [rules.isNumber(json.side)] },
		{
			key: 'cost',
			actual: json.cost,
			rules: [rules.isString(json.cost), rules.noSpaces(json.cost)],
		},
		{
			key: 'confounders',
			actual: json.confounders,
			rules: [
				rules.isArray(json.confounders),
				rules.everyItem(
					json.confounders,
					'every confounder must be a non-null object',
					(c: any) => typeof c === 'object' && c !== null
				),
			],
		},
		{ key: 'base_range', actual: json.base_range, rules: [rules.isNumber(json.base_range)] },
		{ key: 'role', actual: json.role, rules: [rules.isString(json.role)] },
		{ key: 'is_relay', actual: json.is_relay, rules: [rules.isBoolean(json.is_relay)] },
		{
			key: 'protocol_ids',
			actual: json.protocol_ids,
			rules: [rules.optional(json.protocol_ids, rules.isArray(json.protocol_ids))],
		},
		{
			key: 'bandwidth',
			actual: json.bandwidth,
			rules: [rules.optional(json.bandwidth, rules.isNumber(json.bandwidth))],
		},
	];

	return runRules(fields);
}

export const validateEmitter = (data: ValidatedJsonType): ValidationResult => {
	return isEmitterJson(data);
};
